import { render, staticRenderFns } from "./ImageGroupDetails.vue?vue&type=template&id=1e661c9d&scoped=true&"
import script from "./ImageGroupDetails.vue?vue&type=script&lang=js&"
export * from "./ImageGroupDetails.vue?vue&type=script&lang=js&"
import style0 from "./ImageGroupDetails.vue?vue&type=style&index=0&id=1e661c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e661c9d",
  null
  
)

export default component.exports